import {
  REQUEST_A_SELFSIGNUP_LINK_START,
  REQUEST_A_SELFSIGNUP_LINK_COMPLETE,
  REQUEST_A_SELFSIGNUP_LINK_ERROR,
  RESEND_EMAIL_OTP_START,
  RESEND_EMAIL_OTP_COMPLETE,
  RESEND_EMAIL_OTP_ERROR,
  VERIFY_SIGNUP_EMAIL_OTP_START,
  VERIFY_SIGNUP_EMAIL_OTP_COMPLETE,
  VERIFY_SIGNUP_EMAIL_OTP_ERROR,
  CLEAR_SELF_SIGNUP_ERROR,
  SET_SELF_SIGNUP_PASSWORD_START,
  SET_SELF_SIGNUP_PASSWORD_COMPLETE,
  SET_SELF_SIGNUP_PASSWORD_ERROR,
  CREATE_SELFSIGNUP_ACCOUNT_START,
  CREATE_SELFSIGNUP_ACCOUNT_COMPLETE,
  CREATE_SELFSIGNUP_ACCOUNT_ERROR,
} from './actions';
import { LOGOUT } from '../login/actions';

let initialState = {
  requestSelfSignUpLinkStarted: false,
  isVerifySelfSignUpEmailStarted: false,
  isVerifyEmailOtpStarted: false,
  signupToken: undefined,
  resendEmailOtpToken: undefined,
  resendEmailOtpStarted: false,
  resendEmailOtpError: undefined,
  requestSelfSignUpLinkError: undefined,
  isSetSelfSignupPasswordStarted: false,
  setSelfSignupPasswordError: undefined,
  passwordToken: undefined,
  isCreateSelfSignupAccountStarted: false,
  createSelfSignupAccountError: undefined,
};

const reducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case REQUEST_A_SELFSIGNUP_LINK_START:
      return {
        ...state,
        requestSelfSignUpLinkStarted: true,
        requestSelfSignUpLinkError: undefined,
        signupToken: undefined,
      };
    case REQUEST_A_SELFSIGNUP_LINK_COMPLETE:
      return {
        ...state,
        requestSelfSignUpLinkStarted: false,
        requestSelfSignUpLinkError: undefined,
        signupToken: payload.data,
      };
    case REQUEST_A_SELFSIGNUP_LINK_ERROR:
      return {
        ...state,
        requestSelfSignUpLinkError: payload.error,
        requestSelfSignUpLinkStarted: false,
        signupToken: undefined,
      };
    case RESEND_EMAIL_OTP_START:
      return {
        ...state,
        resendEmailOtpStarted: true,
        resendEmailOtpError: undefined,
        resendEmailOtpToken: undefined,
      };
    case RESEND_EMAIL_OTP_COMPLETE:
      return {
        ...state,
        resendEmailOtpStarted: false,
        resendEmailOtpError: undefined,
        resendEmailOtpToken: payload.data,
      };
    case RESEND_EMAIL_OTP_ERROR:
      return {
        ...state,
        resendEmailOtpError: payload.error,
        resendEmailOtpStarted: false,
        resendEmailOtpToken: undefined,
      };
    case VERIFY_SIGNUP_EMAIL_OTP_START:
      return {
        ...state,
        isVerifySignupEmailOtpStarted: true,
        verifySignupEmailOtpError: undefined,
        otpToken: undefined,
      };
    case VERIFY_SIGNUP_EMAIL_OTP_COMPLETE:
      return {
        ...state,
        isVerifySignupEmailOtpStarted: false,
        verifySignupEmailOtpError: undefined,
        otpToken: payload.data,
      };
    case VERIFY_SIGNUP_EMAIL_OTP_ERROR:
      return {
        ...state,
        verifySignupEmailOtpError: payload.error,
        isVerifySignupEmailOtpStarted: false,
        otpToken: undefined,
      };
    case SET_SELF_SIGNUP_PASSWORD_START:
      return {
        ...state,
        isSetSelfSignupPasswordStarted: true,
        setSelfSignupPasswordError: undefined,
        passwordToken: undefined,
      };
    case SET_SELF_SIGNUP_PASSWORD_COMPLETE:
      return {
        ...state,
        isSetSelfSignupPasswordStarted: false,
        setSelfSignupPasswordError: undefined,
        passwordToken: payload.data,
      };
    case SET_SELF_SIGNUP_PASSWORD_ERROR:
      return {
        ...state,
        setSelfSignupPasswordError: payload.error,
        isSetSelfSignupPasswordStarted: false,
        passwordToken: undefined,
      };
    case CREATE_SELFSIGNUP_ACCOUNT_START:
      return {
        ...state,
        isCreateSelfSignupAccountStarted: true,
        createSelfSignupAccountError: undefined,
      };
    case CREATE_SELFSIGNUP_ACCOUNT_COMPLETE:
      return {
        ...state,
        isCreateSelfSignupAccountStarted: false,
        createSelfSignupAccountError: undefined,
      };
    case CREATE_SELFSIGNUP_ACCOUNT_ERROR:
      return {
        ...state,
        createSelfSignupAccountError: payload.error,
        isCreateSelfSignupAccountStarted: false,
      };
    case CLEAR_SELF_SIGNUP_ERROR:
      return {
        ...state,
        requestSelfSignUpLinkError: undefined,
        requestSelfSignUpLinkStarted: false,
        isVerifySignupEmailOtpStarted: false,
        verifySignupEmailOtpError: undefined,
        resendEmailOtpStarted: false,
        resendEmailOtpError: undefined,
        isSetSelfSignupPasswordStarted: false,
        setSelfSignupPasswordError: undefined,
        isCreateSelfSignupAccountStarted: false,
        createSelfSignupAccountError: undefined,
      };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
